export const calculateEngagementScore = ( values ) => {
  let score = 0;

  if( values.msaAgreementSigned ) {
    score += 30;
  }

  if( values.isEmailSubscriber ) {
    score += 10;
  }

  switch( values.emailRating ) {
    case 1:
      score += 10;
      break;
    case 2:
      score += 20;
      break;
    case 3:
      score += 30;
      break;
    case 4:
      score += 40;
      break;
    case 5:
      score += 50;
      break;
  }

  switch( values.emailOpens ) {
    case 1:
      score += 10;
      break;
    case 2:
      score += 20;
      break;
    case 3:
      score += 30;
      break;
    case 4:
      score += 40;
      break;
    case 5:
      score += 50;
      break;
  }

  if( values.isInFacebookGroup ) {
    score += 30;
  }

  const vp = values.totalVideosPublished;
  if( vp > 40 ) {
    score += 50;
  } else if ( vp > 20 ) {
    score += 40;
  } else if ( vp > 10 ) {
    score += 30;
  } else if ( vp > 5 ) {
    score += 20;
  } else if ( vp > 0 ) {
    score += 10;
  }

  if( values.isWebProfileComplete ) {
    score += 30;
  }

  switch( values.eventAttendancePercent ) {
    case 0:
      score += 0;
      break;
    case 25:
      score += 10;
      break;
    case 50:
      score += 20;
      break;
    case 75:
      score += 30;
      break;
    case 100:
      score += 50;
      break;
  }

  if( values.referrals ) {
    // TODO: # of referrals
  
    // console.log( values.referrals );
  }

  if( values.thirtyDayInquiry ) {
    score += 30;
  }

  if( values.sixtyDayInquiry ) {
    score += 10;
  }

  return score;
}